export const saveAppkey = async (appkey, value) => {
  let incomingValue = value || '';
  await window.ignite.answerService.saveAnswer({
    appkey: appkey,
    value: incomingValue,
    timestamp: new Date()
  });
};
